import { createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';

export function createAppRouter() {
  return createRouter({
    routeTree,
    /*
     * Vite's `base`, so the same bundle works from a domain root (Cloudflare
     * Pages, Netlify) and from a GitHub Pages project subpath. Without this the
     * assets resolve but every route 404s on the subpath deploy.
     */
    basepath: import.meta.env.BASE_URL,
    defaultPreload: 'intent',
    scrollRestoration: true,
  });
}

export const router = createAppRouter();

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
